/**
 * ユーザ：通常取得
 */
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $id: ID
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        owner
        licenceLimit {
          nextToken
        }
        licence {
          nextToken
          items {
            active
            id
            owner
            type
            userId
          }
        }
        username
        mailaddress
        companyName
        corp
        active
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;

/**
 * ユーザ：降順取得
 */
export const listUserByUpdatedAt = /* GraphQL */ `
  query ListUserByUpdatedAt(
    $owner: String
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserByUpdatedAt(
      owner: $owner
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        licenceLimit {
          nextToken
        }
        licence {
          nextToken
          items {
            active
            id
            owner
            type
            userId
          }
        }
        username
        mailaddress
        companyName
        corp
        active
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;

/**
 * ライセンス：通常取得
 */
export const listLicences = /* GraphQL */ `
  query ListLicences(
    $id: ID
    $filter: ModelLicenceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLicences(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        licenceBind {
          nextToken
        }
        type
        period
        subscriptionExpiryDateAt
        maintenancePeriod
        acsVersionId
        acsVersion {
          id
          no
          version
          releaseDate
          active
          updatedAt
          createdAt
        }
        licenceKey
        uuid
        active
        updatedAt
        createdAt
        owner
      }
      nextToken
    }
  }
`;

export const getLicenceMaintenanceHistory = /* GraphQL */ `
  query GetLicenceMaintenanceHistory($id: ID!) {
    getLicenceMaintenanceHistory(id: $id) {
      id
      licenceId
      userId
      licence {
        id
        userId
        licenceBind {
          nextToken
        }
        type
        period
        subscriptionExpiryDateAt
        maintenancePeriod
        acsVersionId
        acsVersion {
          id
          no
          version
          releaseDate
          active
          updatedAt
          createdAt
        }
        licenceKey
        uuid
        active
        updatedAt
        createdAt
        owner
      }
      user {
        id
        owner
        licenceLimit {
          nextToken
        }
        licence {
          nextToken
        }
        username
        mailaddress
        telephoneNumber
        postalCode
        address
        companyName
        corp
        active
        updatedAt
        createdAt
      }
      owner
      before
      after
      reason
      beforePeriod
      afterPeriod
      beforeSubscriptionExpiryDateAt
      afterSubscriptionExpiryDateAt
      beforeMaintenancePeriod
      afterMaintenancePeriod
      createdAt
      updatedAt
    }
  }
`;
export const listLicenceMaintenanceHistories = /* GraphQL */ `
  query ListLicenceMaintenanceHistories(
    $filter: ModelLicenceMaintenanceHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLicenceMaintenanceHistories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        licenceId
        userId
        licence {
          id
          userId
          type
          period
          subscriptionExpiryDateAt
          maintenancePeriod
          acsVersionId
          licenceKey
          uuid
          active
          updatedAt
          createdAt
          owner
        }
        user {
          id
          owner
          username
          mailaddress
          telephoneNumber
          postalCode
          address
          companyName
          corp
          active
          updatedAt
          createdAt
        }
        owner
        before
        after
        reason
        beforePeriod
        afterPeriod
        beforeSubscriptionExpiryDateAt
        afterSubscriptionExpiryDateAt
        beforeMaintenancePeriod
        afterMaintenancePeriod
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;